import UploadFlow from "../components/upload-flow/UploadFlow";
import CombinedUploadForm from "../components/upload-form/CombinedUploadForm";


function Upload() {
  return (
    <div className="App">
      {/* <CombinedUploadForm /> */}
      <UploadFlow />
    </div>
  );
}

export default Upload;
